/*
 * @Author: your name
 * @Date: 2021-08-20 12:06:25
 * @LastEditTime: 2026-06-17 19:08:45
 * @LastEditors: qiuhc 2282747917@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \vue-element-ui-admin\src\utils\request.js
 */
import Axios from "axios";
import Config from "@/config/app";
import {
  Notification
  // Loading
} from "element-ui";
import { getToken, removeToken } from "../utils/common";

import router from "@/router";

const service = Axios.create({
  baseURL: Config.apiUrl + "/api" + Config.apiPrefix,
  headers: {
    Accept: "*/*"
  },
  timeout: Config.timeout
});
service.defaults.retry = Config.requestRetry;
service.defaults.retryDelay = Config.requestRetryDelay;

service.interceptors.request.use(
  config => {
    // if (!config.closeLoading) {
    //   window.loadingInstance = Loading.service();
    // }
    config.headers[Config.tokenKey] = getToken();
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// 与后台 BizCode 对齐：0 成功；11xxx 鉴权；12xxx 校验/业务；13xxx 资源；15xxx 系统
const BIZ_OK = 0;
const AUTH_REQUIRED = 11001; // 未登录 / token 失效（原 204）
const AUTH_DENIED = 11003; // 已登录但无权限（原 206）

service.interceptors.response.use(
  res => {
    console.log(res);
    // if (!res.config.closeLoading) {
    //   window.loadingInstance.close();
    // }
    if (res.status !== 200) {
      Notification({
        title: "数据返回出错",
        message: "请稍后重试",
        type: "warning"
      });
      return Promise.reject("error");
    }

    const { code, msg } = res.data || {};

    // 未登录 / token 失效 → 清登录态
    if (code === AUTH_REQUIRED) {
      removeToken();
      Notification({
        title: msg || "请先登录",
        message: "请重新登录",
        type: "warning"
      });
      router.push("/login");
      return Promise.reject("error");
    }

    // 无权限
    if (code === AUTH_DENIED) {
      Notification({
        title: msg || "无权限",
        message: "请联系管理员",
        type: "error"
      });
      return Promise.reject("error");
    }

    // 其它业务失败（校验 12xxx / 资源 13xxx / 系统 15xxx 等）
    if (code !== BIZ_OK) {
      Notification({
        title: msg || "操作失败",
        message: "请稍后重试",
        type: "warning"
      });
      return Promise.reject("error");
    }

    return res.data;
  },
  error => {
    // window.loadingInstance.close();
    Notification({
      title: "请求未响应",
      message: "服务器可能出了点问题",
      type: "warning"
    });
    return Promise.reject(error); //不能去掉，否则请求超时会进入到then方法，导致逻辑错误。
  }
);

export default service;
